// extracted by mini-css-extract-plugin
export default {"anchor":"GameLink_anchor__VdrCy"};